import { Skeleton } from 'components/ui';

export default function RetentionHeatmapLoadingState() {
  return (
    <Skeleton isLoaded={false}>
      <div className="w-full mt-4" style={{ height: '515px' }} />
    </Skeleton>
  );
}
